/*
 *  (c) 2015 - 2022 ENISCO by FORCAM GmbH
 */

import {Tab, Tabs} from '@mui/material'
import React, {Fragment} from 'react'
import AllAppsTab from './tabs/apps/AllAppsTab'
import FavoritesTab from './tabs/favorites/FavoritesTab'
import {FormattedMessage} from 'react-intl'

const TabBar: React.FC<{handleClose: () => void}> = ({handleClose}) => {
  const [value, setValue] = React.useState(0)

  const handleChange = (
    event: React.ChangeEvent<NonNullable<unknown>>,
    newValue: number
  ) => {
    setValue(newValue)
  }

  return (
    <Fragment>
      <Tabs
        value={value}
        onChange={handleChange}
        variant='scrollable'
        aria-label='emes apps'
      >
        <Tab label={<FormattedMessage id='Tab.Apps' defaultMessage='Apps' />} />
        <Tab
          label={
            <FormattedMessage id='Tab.Favorites' defaultMessage='Favorites' />
          }
        />
      </Tabs>
      <AllAppsTab handleClose={handleClose} value={value} index={0} />
      <FavoritesTab handleClose={handleClose} value={value} index={1} />
    </Fragment>
  )
}

export default TabBar
